<div v-show="show" :class="rootClasses"><mdicon name="loading" :spin="true" :size="size"></mdicon></div>